// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du compte layout wrapper
import UtilisateurProfileLayout from './UtilisateurProfileLayout';

import UtilisateurService from '../../services/UtilisateurService';

const DeleteUtilisateur = () => {
	const [utilisateur, setUtilisateur] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([UtilisateurService.getUtilisateur(id)]).then(
			([utilisateurData]) => {
				setUtilisateur(utilisateurData.data);
			}
		);
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the UtilisateurService to delete the utilisateur
			await UtilisateurService.deleteUtilisateur(id);

			// Redirect the user to the list of utilisateurs
			navigate('/administration/utilisateurs');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression des informations de l'utilisateur",
				error
			);
		}
	};

	return (
		<UtilisateurProfileLayout>
			{utilisateur && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">
											{utilisateur.nom || ''}
										</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement le compte de cet utilisateur.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez le compte de cet utilisateur, il ne pourra plus acceder à la plateforme de gestion scolaire.
								</p>
								<Button variant="danger" type="submit">
									Supprimer le compte de l'utilisateur
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</UtilisateurProfileLayout>
	);
};

export default DeleteUtilisateur;
